import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import AddSubscriberForm from '../../elements/AddSubscriberForm';
import FooterOne from '../../common/footer/FooterOne';



const RegisterSubscriber = () => {
    
    return (
        <>
        <HeaderOne />
        
        <AddSubscriberForm />
                
        <FooterOne />
        </>
    )
}
    
export default RegisterSubscriber ;